module.exports = __webpack_public_path__ + "img/server-monitor-exchange.f5853028.svg";